export const CAMPAIGN_STATUS = {
  paused: 'paused',
  running: 'running',
  draft: 'draft',
};

export const isCampaignRunning = (status) => status === CAMPAIGN_STATUS.running;

export const isCampaignDraft = (status) => status === CAMPAIGN_STATUS.draft;
